import { dexieRepo } from './dexieRepo';
import type { GameRepository } from './types';

export type {
  GameRecord,
  GameRepository,
  RulebookRecord,
  SavedPlayer,
  SavedTeam,
  SavedTournament,
} from './types';
export { findTeamByName, newTeamId, sameTeamName } from './teams';
export { createMemoryRepo } from './memoryRepo';

let repo: GameRepository = dexieRepo;

/** The app's repository. Tests can swap it with setRepository(createMemoryRepo()). */
export const getRepository = (): GameRepository => repo;
export const setRepository = (r: GameRepository): void => {
  repo = r;
};
